<h2 mat-dialog-title align="center">{{ brandCareTitle }}</h2>
<mat-divider></mat-divider>
<mat-dialog-content>
  <p style="white-space: pre-line">{{ data.message }}</p>
</mat-dialog-content>
<mat-dialog-actions align="center">
  <button class="ok-btn" mat-button color="primary" (click)="onOk()">
    {{
      data.type === "confirm"
        ? ("dimbo.i18n.brandcareForm.button.yes" | translate)
        : ("dimbo.i18n.brandcareForm.button.ok" | translate)
    }}
  </button>
  <button
    class="cancel-btn"
    mat-button
    *ngIf="data.type === 'confirm'"
    (click)="onCancel()"
  >
    {{ "dimbo.i18n.brandcareForm.button.no" | translate }}
  </button>
</mat-dialog-actions>
